// src/utils/connectedProfileMapping.ts
import { ConnectedProfile } from "../types/customer";

export function mapConnectedProfiles(rawProfiles: any): ConnectedProfile[] {
  if (!Array.isArray(rawProfiles)) return [];
  return rawProfiles.map((profile: any) => ({
    platform: profile.platform,
    details: Array.isArray(profile.details)
      ? profile.details.map((detail: any) => ({
          id: detail.id,
          metadata: detail.metadata || {},
        }))
      : [],
  }));
}